import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getSingleCourse, addToCart, addToWishlist } from "../Common/apis";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import img from "../Assets/Course app-pana (1) 4.png";
import Loader from "../Loader/Loader.jsx";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Navbar2 from "../Components/Navbar2.jsx";
import Footer2 from "../Components/Footer2.jsx";
import Aos from "aos";
import CourseReview from "./CourseReview.jsx";
import CourseQuiz from "./CourseQuiz.jsx";
// import icon from '/assets/home/icon1.svg'
// import icon2 from '/assets/home/icon2.svg'
// import icon3 from '/assets/home/icon3.svg'
// import icon4 from '/assets/home/icon4.svg'
// import icon5 from '/assets/home/icon5.svg'


function CoursesDetails() {
  useEffect(() => {
    Aos.init({
      duration: 1000, // animation duration in ms
      once: true,     // animate only once
    });
  }, []);
  const { courseId } = useParams();
  const navigate = useNavigate();
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("GISUL_TOKEN");
  const [activeTab, setActiveTab] = useState('Professionals');
  const tabs = [
    'Professionals',
    'Overview',
    'Curriculum',
    'Quiz',
    'Certificate',
    'Reviews',
  ];


  console.log(course);
  useEffect(() => {
    getSingleCourse(courseId)
      .then((res) => {
        setCourse(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching course:", err);
        setLoading(false);
      });
  }, [courseId]);

  // if (loading) return <p>Loading...</p>;
  //   if (!course) return <p>Course not found!</p>;

  const addToWish = async (courseId) => {
    if (!token) {
      toast.error("Please login to add course to wishlist.");
      navigate("/login");
      return;
    }
    try {
      await addToWishlist({ courseId });
      toast.success("Course added to wishlist!");
    } catch (error) {
      console.error("Error adding to wishlist:", error);
      toast.error("Failed to add course to wishlist.");
    }
  };

  return (
    <div className="new-home">
      <Navbar2 />
      <br />

      {loading ? <Loader /> : null}
      <div className="">
        <h2 data-aos="flip-up" className="font-[400] font-sans md:text-[40px] text-[30px] md:leading-[40px] leading-[30px] tracking-[-0.32px] text-[#FFFFFF] text-center">
          Courses Details <br />
          {/* <i>AWS Skill builder</i> */}
        <span className="xl:text-[80px] md:text-[74px] text-[40px] text-[#F1E60D] xl:leading-[132px] md:leading-[82px] leading-[40px]">{course?.name}</span>
        </h2>
      </div>
      {/* <div className="time-div">
        <div className="time-slot">
          <div className="timespan-div">
            <div>
              <div className="timespan"></div>
            </div>
            <div className="timespan-text">
              <h4>Time Span</h4>
              <p>4 weeks</p>
            </div>
          </div>
          <div className="timespan-div">
            <div>
              <div className="timespan"></div>
            </div>
            <div className="timespan-text">
              <h4>Time Span</h4>
              <p>4 weeks</p>
            </div>
          </div>
          <div className="timespan-div">
            <div>
              <div className="timespan"></div>
            </div>
            <div className="timespan-text">
              <h4>Time Span</h4>
              <p>4 weeks</p>
            </div>
          </div>
          <div className="timespan-div">
            <div>
              <div className="timespan"></div>
            </div>
            <div className="timespan-text">
              <h4>Time Span</h4>
              <p>4 weeks</p>
            </div>
          </div>
        </div>
      </div> */}
      <div className="md:block hidden">
        <div className="time-div pt-[40px] overflow-hidden">
          <div className="time-slot">
            <div data-aos="fade-up" className="timespan-div">
              <img src="/assets/home/icon1.svg" alt="" />
              <div className="timespan-text">
                <h4>Duration</h4>
                <p>{course?.duration}</p>
              </div>
            </div>
            <div data-aos="fade-down" className="timespan-div">
              <img src="/assets/home/icon2.svg" alt="" />

              <div className="timespan-text">
                <h4>Lectures</h4>
                <p>{course?.lectures}</p>
              </div>
            </div>
            <div data-aos="fade-up" className="timespan-div">
              <img src="/assets/home/icon3.svg" alt="" />

              <div className="timespan-text">
                <h4>Video Lessons</h4>
                <p>{course?.videoLessons}</p>
              </div>
            </div>
            <div data-aos="fade-down" className="timespan-div">
              <img src="/assets/home/icon4.svg" alt="" />

              <div className="timespan-text">
                <h4>Skill Level</h4>
                <p>{course?.skillLevel}</p>
              </div>
            </div>
            <div data-aos="fade-up" className="timespan-div">
              <img src="/assets/home/icon5.svg" alt="" />

              <div className="timespan-text">
                <h4>Students Enrolled</h4>
                <p>{course?.studentsEnrolled}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="md:hidden block">
        <div className="time-div pt-[40px]">
          <div style={{ border: "1px solid", borderImageSource: "linear-gradient(180deg, #B99FFF 0%, rgba(111, 95, 153, 0) 100%)" }} className="grid grid-cols-2 gap-[20px] max-w-[372px] mx-auto w-full rounded-[16px] bg-[#6953A3] px-[24px] py-[33px] overflow-hidden">
            <div data-aos="fade-up" className="timespan-div">
              <img src="/assets/home/icon1.svg" alt="" />
              <div className="timespan-text">
                <h4>Duration</h4>
                <p>{course?.duration}</p>
              </div>
            </div>
            <div data-aos="fade-right" className="timespan-div">
              <img src="/assets/home/icon2.svg" alt="" />

              <div className="timespan-text">
                <h4>Lectures</h4>
                <p>{course?.lectures}</p>
              </div>
            </div>
            <div data-aos="fade-up" className="timespan-div">
              <img src="/assets/home/icon3.svg" alt="" />

              <div className="timespan-text">
                <h4>Video Lessons</h4>
                <p>{course?.videoLessons}</p>
              </div>
            </div>
            <div data-aos="fade-right" className="timespan-div">
              <img src="/assets/home/icon4.svg" alt="" />

              <div className="timespan-text">
                <h4>Skill Level</h4>
                <p>{course?.skillLevel}</p>
              </div>
            </div>
            <div data-aos="fade-up" className="timespan-div">
              <img src="/assets/home/icon5.svg" alt="" />

              <div className="timespan-text">
                <h4>Students Enrolled</h4>
                <p>{course?.studentsEnrolled}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="Coursedescription">
        <div className="Coursedescription-left overflow-hidden">
          <div className="enroll-div">
            <img data-aos="fade-right" src={course?.images[0]} alt={course?.name} />
            <br />
            <button>$ {course?.price} USD</button>
            &nbsp;
            <button
              data-aos="fade-up"
              onClick={() => {
                if (!token) {
                  toast.error("Please login to add course to cart.");
                  navigate("/login");
                  return;
                }
                addToCart({ courseId: course._id, quantity: 1 })
                  .then((res) => {
                    console.log(res.data);
                    toast.success("Course added to cart!");
                  })
                  .catch((err) => {
                    console.error("Error adding course to cart:", err);
                    toast.error("Failed to add course to cart!");
                  });
              }}
            >
              <i className="fa fa-shopping-cart" aria-hidden="true"></i> Add to
              Cart
            </button>
            &nbsp;
            <button data-aos="fade-right" onClick={() => addToWish(course._id)} className="bt1">
              <i className="fa fa-heart" aria-hidden="true"></i> Add to Wishlist
            </button>
          </div>
        </div>
        <div className="Coursedescription-right">
          <div style={{ maxWidth: "100%" }} className="cards-tab cards-tab2">
            {tabs.map((tab) => (
              <button
                key={tab}
                className={activeTab === tab ? 'active' : ''}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </button>
            ))}

            {/* <button>Students</button>
            <button>Beginners</button>
            <button>Experts</button> */}
          </div>
          {activeTab === "Professionals" &&
            <div className="grid grid-cols-1 overflow-hidden gap-[20px]">
              <div data-aos="fade-right" className="Coursedescription-text">
                <h3 className="font-sans leading-[36px] pb-[10px]">Course Description</h3>
                {/* <p>{course?.description}</p> */}
                <div dangerouslySetInnerHTML={{ __html: course?.description }} ></div>
              </div>
              <div data-aos="fade-left" className="Coursedescription-text">
                <h3>Main Features</h3>
                {/* <ul>
              <li>{course?.feature}</li>
            </ul> */}
                <div dangerouslySetInnerHTML={{ __html: course?.feature }} ></div>
              </div>
              <div data-aos="fade-right" className="Coursedescription-text">
                <h3>Target Audience</h3>
                {/* <p>{course?.audience}</p> */}
                <div dangerouslySetInnerHTML={{ __html: course?.audience }} ></div>
              </div>
            </div>
          }
          {activeTab === "Overview" &&
            <div className="grid grid-cols-1 overflow-hidden gap-[20px]">
              <div data-aos="fade-right" className="Coursedescription-text">
                {/* <h3 className="font-sans leading-[36px] pb-[10px]">Course Description</h3> */}
                {/* <p>{course?.description}</p> */}
                <div dangerouslySetInnerHTML={{ __html: course?.overview }} ></div>
              </div>
            </div>
          }
          {activeTab === "Curriculum" &&
            <>
              <div className="bg-[#6953A3B2] rounded-[16px] p-[28px]" style={{ backdropFilter: "blur(20px)" }}>
                <h6 className="font-[700] font-sans text-[24px] leading-[36px] text-[#FFFFFF] pb-[16px]">Curriculum Table</h6>
                <div className="grid grid-cols-1 gap-[12px]">
                  {/* <div className="flex justify-around items-center bg-[#F1E60D] rounded-full py-[12px]"> */}
                    {/* <p className="font-[500] font-sans text-[18px] leading-[24px] tracking-[-0.32px] max-w-[193px] text-center w-full text-[#263238]">No</p> */}
                    {/* <p className="font-[500] font-sans text-[18px] leading-[24px] tracking-[-0.32px] max-w-[435px] text-center w-full text-[#263238]">Chapter</p> */}
                    {/* <p className="font-[500] font-sans text-[18px] leading-[24px] tracking-[-0.32px] max-w-[193px] text-center w-full text-[#263238]">Pages</p> */}
                  {/* </div> */}
                  {course?.curriculum?.map((e, i) => {
                    return (
                      <div key={i} className="flex justify-around items-center">
                        {/* <p className="font-[500] font-sans text-[18px] bg-[#FFFFFF] py-[12px] text-center max-w-[193px] w-full leading-[24px] tracking-[-0.32px] text-[#263238] rounded-full">{i + 1}</p> */}
                        <div className="  bg-[#FFFFFF] py-[12px]  w-full leading-[24px] tracking-[-0.32px]" style={{borderRadius: "15px", padding: "12px"}} dangerouslySetInnerHTML={{ __html: e?.description }} ></div>
                        {/* <p className="font-[500] font-sans text-[18px] bg-[#FFFFFF] py-[12px] text-center max-w-[193px] w-full leading-[24px] tracking-[-0.32px] text-[#263238] rounded-full">2</p> */}
                      </div>
                    )
                  })}
                </div>
              </div>
            </>}
          {activeTab === "Quiz" &&
           <CourseQuiz  course={course} />
           }
          {activeTab === "Certificate" &&
            <>
              <div className="bg-[#6953A3B2] rounded-[16px] p-[28px]" style={{ backdropFilter: "blur(20px)" }}>
                <div className="pb-[20px]">
                  <h6 className="font-[700] font-sans text-[24px] leading-[36px] text-[#FFFFFF]">Certificate</h6>
                </div>
                <div className="relative w-[845px] h-[576px] rounded-[30px] overflow-hidden">
                  <img
                    src={course?.certificateDemo}
                    alt="Blurred background"
                    class="absolute top-0 left-0 w-full h-full object-cover"
                  />
                  {/* <div className="relative z-10 h-[576px]">
                    <h6 className="font-[700] text-[60px] text-center text-[#FFFFFF] pt-[5px] font-charm pb-[12px]">Certificate</h6>
                    <p className="font-[500] text-[20px] font-sans text-center text-[#FFFFFF] pt-[12px] pb-[130px]">OF COMPLETION</p>
                    <p className="font-[500] text-[18px] font-sans text-[#263238] text-center">This is to Certify that Mr/ Mrs</p>
                    <h6 className="font-[700] font-charm text-[40px] text-center text-[#745FAC]">Claudia Alves</h6>
                    <div className="bg-[#000000] h-[2px] max-w-[438px] w-full mx-auto">
                    </div>
                    <p className="font-[600] text-[18px] font-sans text-[#263238] text-center pt-[18px] pb-[14px]">Has Successfully completed the </p>
                    <h6 className="font-[700] font-sans text-[24px] text-[#6953A3] text-center pb-[12px]">ASW Skill Builder Course</h6>
                    <h6 className="font-[900] font-sans text-[24px] text-center text-[#263238]">“We Appreciate Your Efforts”</h6>
                    <div className="absolute bottom-[17px] w-full flex justify-between items-center px-[50px]">
                      <div className="flex flex-col items-center">
                        <img src="/assets/slider/signature.png" className="pb-[12px]" alt="" />
                        <div className="bg-[#000000] h-[2px] max-w-[142px] w-full"></div>
                        <h6 className="font-[700] font-sans text-[20px] text-[#000000] pt-[13px]">Mr.Hemant Gupta </h6>
                        <p className="font-[400] text-[16px] font-sans text-[#000000]">Founder & President</p>
                      </div>
                      <div className="flex flex-col items-center">
                        <img src="/assets/slider/signature.png" className="pb-[12px]" alt="" />
                        <div className="bg-[#000000] h-[2px] max-w-[142px] w-full"></div>
                        <h6 className="font-[700] font-sans text-[20px] text-[#000000] pt-[13px]">Mr.Sneha Sharma </h6>
                        <p className="font-[400] text-[16px] font-sans text-[#000000]">Professor</p>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </>}
          {activeTab === "Reviews" &&
            <CourseReview course={course} />
            }
        </div>
      </div>
      {/* <div className="Coursedescription">
        <div className="Coursedescription-left">
          <div className="enroll-div">
            <img src={img} />
            <br />
            <button>$ 99.00 USD</button>
          </div>
        </div>
        <div className="Coursedescription-right">
          <div className="cards-tab cards-tab2">
            <button className="active">Professionals</button>
            <button>Professionals</button>
            <button>Professionals</button>
            <button>Professionals</button>
          </div>
          <br />
          <div className="Coursedescription-text">
            <h3>Course description</h3>
            <br />
            <p>
              E-learning instructors for programming courses typically have
              expertise in one or more programming languages and are experienced
              in designing and delivering online courses. They should have a
              deep understanding of the programming concepts.
            </p>
          </div>
          <br />
          <div className="Coursedescription-text">
            <h3>Main Features</h3>
            <br />
            <ul>
              <li>Lorem ipsum dolor sit amet consectetur.</li>
              <li>Lorem ipsum dolor sit amet consectetur.</li>
              <li>Lorem ipsum dolor sit amet consectetur.</li>
              <li>Lorem ipsum dolor sit amet consectetur.</li>
              <li>Lorem ipsum dolor sit amet consectetur.</li>
              <li>Lorem ipsum dolor sit amet consectetur.</li>
            </ul>
          </div>
          <br />
          <div className="Coursedescription-text">
            <h3>What Is The Target Audience?</h3>
            <br />
            <p>
              Lorem ipsum dolor sit amet consectetur. Nibh urna quis tempus elit
              ultrices amet. Convallis facilisis duis vivamus ut suspendisse
              imperdiet vel eleifend maecenas. Mi senectus eu nec mattis lacus
              dolor in diam cursus. Eu magna enim sed duis enim fames vitae
              ornare pretium. Consequat egestas amet eget neque sed. Quis
              elementum amet diam sapien adipiscing dis dignissim.
            </p>
          </div>
        </div>
      </div> */}
      <Footer2 />
    </div>
  );
}

export default CoursesDetails;
